import { render, staticRenderFns } from "./DataSourceQuickIndex.vue?vue&type=template&id=1a971eca&scoped=true&"
import script from "./DataSourceQuickIndex.vue?vue&type=script&lang=js&"
export * from "./DataSourceQuickIndex.vue?vue&type=script&lang=js&"
import style0 from "./DataSourceQuickIndex.vue?vue&type=style&index=0&id=1a971eca&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a971eca",
  null
  
)

export default component.exports